export function isElementInViewport(elementRef: React.RefObject<HTMLElement>): boolean {
  if (!elementRef.current) return false;

  const elementRect = elementRef.current.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  return (
    elementRect.top >= 0 &&
    elementRect.left >= 0 &&
    elementRect.bottom <= viewportHeight &&
    elementRect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Sets the height of a textarea to fit its content, in other words, it makes the textarea auto-expandable.
 *
 */
export function setTextAreaHeight(textarea: HTMLTextAreaElement) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  textarea.style.height = 0;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  textarea.style.height = textarea.scrollHeight + 'px';
}
